module.exports = __webpack_public_path__ + "img/omar_chat1.51d72dd5.svg";